export default () => {
  try {
    return localStorage.getItem('token') || sessionStorage.getItem('token')
  } catch (e) {
    return null
  }
}
